/* TOP only. Metadata and cards both come from current Shopify Liquid objects. */
(() => {
  const historyHandles = (stored) => {
    let history;
    try { history = JSON.parse(stored || '[]'); } catch { return []; }
    if (!Array.isArray(history)) return [];
    return [...new Set(history.slice().reverse().map((item) => {
      const match = String(item?.productUrl || '').match(/\/products\/([^?#/]+)/);
      try { return match ? decodeURIComponent(match[1]) : ''; } catch { return ''; }
    }).filter(Boolean))].slice(0, 10);
  };
  const concernTags = (product) => (product.tags || []).filter((tag) =>
    /ダメージ|くせ|うねり|スカルプ|頭皮|カラー|色持|エイジング|敏感|保湿|乾燥|毛穴|ハリ|ツヤ|育毛|補修|UV|ブリーチ|紫外線|まとまり/.test(tag));
  const selectHandles = (catalog, handles, fallback) => {
    if (!handles.length) return fallback.slice(0, 10);
    const viewed = handles.map((handle) => catalog.find((p) => p.handle === handle)).filter(Boolean);
    const ranked = catalog.filter((p) => p.available && !handles.includes(p.handle)).map((product, index) => {
      let priority = 3;
      let recency = Infinity;
      viewed.forEach((previous, position) => {
        const match = product.brand && product.brand === previous.brand ? 0
          : product.type && product.type === previous.type ? 1
          : concernTags(product).some((tag) => concernTags(previous).includes(tag)) ? 2 : 3;
        if (match < priority || (match === priority && position < recency)) {
          priority = match;
          recency = position;
        }
      });
      return { handle: product.handle, priority, recency, index };
    }).filter((p) => p.priority < 3)
      .sort((a, b) => a.priority - b.priority || a.recency - b.recency || a.index - b.index);
    // Fewer than ten matches: fill remaining slots with the approved staff selection.
    return [...new Set([...ranked.map((p) => p.handle), ...fallback.filter((h) => !handles.includes(h)), ...fallback])].slice(0, 10);
  };
  const root = () => window.Shopify?.routes?.root || '/';
  let catalogPromise;
  const readDocument = async (url) => {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Staff recommendation response unavailable');
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  };
  const getCatalog = () => {
    if (!catalogPromise) catalogPromise = (async () => {
      const products = [];
      const visited = new Set();
      let next = root();
      while (next) {
        const url = new URL(next, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid catalog origin');
        url.searchParams.set('section_id', 'be-staff-catalog');
        if (visited.has(url.href)) throw new Error('Repeated catalog page');
        visited.add(url.href);
        const doc = await readDocument(url.href);
        const data = JSON.parse(doc.querySelector('[data-staff-catalog]')?.textContent || 'null');
        if (!Array.isArray(data?.products)) throw new Error('Invalid catalog response');
        products.push(...data.products);
        next = data.next;
      }
      return products;
    })().catch((error) => { catalogPromise = null; throw error; });
    return catalogPromise;
  };
  const states = new WeakMap();
  const load = (section, slider) => {
    let stored = '';
    try { stored = localStorage.getItem(section.dataset.recentSource) || ''; } catch { /* Storage disabled: approved fallback. */ }
    const previous = states.get(section);
    if (previous?.stored === stored) return previous.promise;
    const state = { stored };
    states.set(section, state);
    const configuredFallback = (section.dataset.recommendationFallback || '').split(',').filter(Boolean);
    const fallback = configuredFallback.length ? configuredFallback : Array.from(slider.querySelectorAll('[data-product-group="staff_all"]'), (card) => card.dataset.productHandle);
    const handles = historyHandles(stored);
    state.promise = (async () => {
      // Initial Liquid markup already provides the complete no-history fallback.
      if (!handles.length && !previous) return;
      const selected = handles.length ? selectHandles(await getCatalog(), handles, fallback) : fallback;
      const cards = await Promise.all(selected.map(async (handle) => {
        const doc = await readDocument(`${root()}products/${encodeURIComponent(handle)}?section_id=be-staff-card`);
        const card = doc.querySelector('.be-product-card[data-product-group="staff_recent"]');
        if (!card) throw new Error('Recommendation card unavailable');
        return card;
      }));
      if (states.get(section) !== state) return;
      slider.querySelectorAll('[data-product-group="staff_recent"]').forEach((card) => card.remove());
      slider.append(...cards);
    })().catch(() => {
      // Preserve existing real fallback cards on network failure; allow retry.
      if (states.get(section) === state) states.delete(section);
    });
    return state.promise;
  };
  window.BeStaffRecommendations = { load, historyHandles, selectHandles };
})();
